@if (filterForm) {
<div class="link-workday-project-container">
    <div class="workday-header">
        <h3>Link Strategy Outcomes to {{ projectOutcome.outcome?.uniqueId }} - {{ projectOutcome.outcome?.outcomeMetric?.name }}</h3>
    </div>
    <div class="filter-panel">
        <div class="filters" [formGroup]="filterForm">
            <div class="freetext-filter-panel">
                <input class="freetext-filter" placeholder="Search by Outcome ID or Outcome Statement"
                    formControlName="searchTerm">
            </div>
        </div>
    </div>
    @if (pagedAvailableParentOutcomes?.length) {
        <div class="results-panel">
            <div class="results-header">
                <div>Link Outcome</div>
                <div>Outcome ID</div>
                <div>Metric / Unit</div>
                <div>Strategy ID</div>
                <div>Strategy Name</div>
                <div>Outcome Statement</div>
            </div>
            <div class="results-grid">
                @for (availableParent of pagedAvailableParentOutcomes; track availableParent.projectOutcome.projectOutcomeId) {
                <div class="result-row" [ngClass]="{'linked': isAlreadyLinked(availableParent)}">
                    <div>
                        @if (isAlreadyLinked(availableParent)) {
                            <div style="color: #49a942; font-weight: 500;">
                                Linked
                                <img src="assets/images/checkmark.png" style="width: 20px; margin-left: 5px">
                            </div>
                        } @else {
                            <button (click)="linkParent(availableParent)">
                                <div>Link</div>
                                <img src="assets/images/icons/link_icon_white.png">
                            </button>
                        }
                    </div>
                    <div>
                        @if (availableParent.projectOutcome.outcome) {
                            {{ availableParent.projectOutcome.outcome.uniqueId }}
                        } @else {
                            {{ availableParent.projectOutcome.customOutcome?.uniqueId }}
                        }
                    </div>
                    <div>
                        @if (availableParent.projectOutcome.outcome) {
                            {{ availableParent.projectOutcome.outcome.outcomeMetric?.name }} / {{ availableParent.projectOutcome.outcome.outcomeUnit?.name }}
                        } @else {
                            {{ availableParent.projectOutcome.customOutcome?.indicatorName }} / {{ availableParent.projectOutcome.customOutcome?.unit }}
                        }
                    </div>
                    <div>{{ availableParent.strategyId }}</div>
                    <div>
                        {{ availableParent.strategyName }}
                        @if(availableParent.isPrimaryStrategy) {
                            <span class="text-success">&nbsp;*</span>
                        }

                    </div>
                    <div>{{ availableParent.projectOutcome.statement }}</div>
                </div>
                }
            </div>
        </div>
        <div class="results-grid-footer">* Indicates Primary Strategy</div>
    } @else {
        <div>
            <div class="alert alert-info alert-styled-left shadow-0" style="margin-top: 40px;">
                There are no matching Outcomes to link to.
            </div>
        </div>
    }
    <div class="pager-panel">
        @if (pagedAvailableParentOutcomes?.length) {
            <app-hub-paginator [currentPage]="currentPage" [totalItems]="availableParentOutcomes.length"
                [totalPages]="totalPages" (pageRequested)="pageRequested($event)">
            </app-hub-paginator>
        }
    </div>
    <div class="actions-footer">
        <button (click)="close()">
            <div>Done</div>
        </button>
    </div>
</div>
}
